// extracted by mini-css-extract-plugin
export default {"wordCompare":"WordCompare_wordCompare__uSR8-","wordCompare_row":"WordCompare_wordCompare_row__mjdIu","error":"WordCompare_error__sOOzY"};